import { createContext, useContext, useState, useEffect, useCallback } from "react";
import portalApi from "@/lib/portalApi";

const PortalAuthContext = createContext(null);

function getToken() { return localStorage.getItem("portal_access_token"); }
function setToken(t) { localStorage.setItem("portal_access_token", t); }
function clearToken() { localStorage.removeItem("portal_access_token"); }

export function PortalAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = getToken();
    if (!token) { setUser(false); setLoading(false); return; }
    try {
      const { data } = await portalApi.get("/portal/me");
      setUser(data);
    } catch {
      clearToken();
      setUser(false);
    }
    setLoading(false);
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await portalApi.post("/portal/login", { email, password });
    setToken(data.access_token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    clearToken();
    setUser(false);
  };

  return (
    <PortalAuthContext.Provider value={{ user, loading, login, logout, checkAuth }}>
      {children}
    </PortalAuthContext.Provider>
  );
}

export function usePortalAuth() {
  return useContext(PortalAuthContext);
}
